module.exports = __webpack_public_path__ + "static/media/ie.1c12635a.svg";